import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {ResourcesRequestsService} from "../../services/resources-requests.service";

export class ResourceAllocationSelectListCtrl implements IController {

  selectedResourceAllocation: any;
  options: any;
  from: any;
  to: any;
  resourceIds: any;
  serviceAreaIds: any;
  skills: any;
  isActive: boolean;
  branchIds: any;
  excludeRouted: boolean;
  excludeIds: any;
  ngPlaceholder: any;
  onChange: Function;

  public excludedMap: any;
  public loading: boolean;
  public resourceAllocations: any;


  private queryString: any;
  private selectedKeys: any;

  /* @ngInject */
  constructor(private $log, private $filter, private resourcesRequestsService: ResourcesRequestsService) {
  }

  $onInit() {
    this.queryString = undefined;
    this.loading = true;
    this.resourcesRequestsService.getResourceAllocationsInstances(this.branchIds, this.from, this.to, this.skills, this.isActive, this.excludeRouted)
      .then((resourceAllocations) => {
        this.resourceAllocations = resourceAllocations;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
  }

  getAllocationName(allocation) {
    if (!allocation) {
      return;
    }
    return `${allocation.resourceName} - ${this.$filter('bringozDate')({startTime: allocation.schedule.startTime}, 'startTime', true)}`
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationSelectList', {
    bindings: {
      selectedResourceAllocation: '<',
      branchIds: '<?',
      from: '<?',
      to: '<?',
      resourceIds: '<?',
      serviceAreaIds: '<?',
      skills: '<?',
      isActive: '<?',
      options: '<?',
      excludeIds: '<?',
      excludeRouted: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./resource-allocation-select-list.html').default,
    controller: ResourceAllocationSelectListCtrl
  });
